import React, { Component } from 'react';
import _ from 'lodash';
import TextInput from '../../../../../components/ZUILib/TextInput';
import RadioButton from '../../../../../components/ZUILib/RadioButton';
import InputButton from '../../../../../components/ZUILib/InputButton';
import SelectionTab from '../../../../../components/ZUILib/SelectionTab';
import commonUtil from '../../../../../utils/commonUtil';
import * as typeActions from '../../actions';

const channel = commonUtil.getChannel();
const constChannels = commonUtil.getClientConstForChannel();

const { getEwalletInfo } = typeActions;
export default class panel1 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      transferenceData: this.props.transferenceData.transferenceOptions,

      selectedDropdownAvailableWalletsInfoValue: '',
      selectedDropdownAvailableWalletsInfoText: '',

      selectedRadioSavedWalletsInfoValue: '',

      walletNumber_mmdr: '',
      walletAmount_mmdr: '0.00',
      walletAmount_mdw: '0.00',
      walletAmount_mew: '0.00',

      walletAmount_mltpc: '0.00',
      walletNumber_mltpc: '',
      beneficiaryName_mltpc: '',

      commissionFeeForMEE: '',
      commissionFeeForMLPC: '',
      commissionFeeForMMDR: '',
      commissionFeeForMDW: '',

      isUserHasWallet: false,
      isMonederoDetails: false,
      isCardNumberVisible: false,
      isBeneficiaryNameVisible: false,

      isMonederoMesadeRegalos: false,
      isMonederoElectronico: false,
      isMonederoLiverpool_TarjetaPremiumCard: false,
      isMonederoLiverpool_TarjetaPremiumCard_New: false,
      isMonederoDigitalWallet: false,
      isNuevaCuentaDisabled: false,
      walletStatus: false,
      eWalletNumber: '',
      walleterrorMessage: '',
      isWalletamountError: false,
    };
  }

  getEwalletInformation = () => {
    if (!this.state.walletStatus) {
      const profileId = this.props.user.profileId;
      getEwalletInfo(profileId).then((response) => {
        if (response.body.status.status !== 'failure') {
          this.setState({ walletStatus: true, eWalletNumber: response.body.eWalletAccountNum });
        } else {
          this.setState({ walleterrorMessage: response.body.status.errorMessage });
        }
      });
    }
  }

  onExceptionKeysCheck = (e) => {
    if (e.which === 46 || e.which === 43 || e.which === 101 || e.which === 69 || e.which === 45) {
      e.preventDefault();
    }
  }

  onExceptionKeysCheckForAmount = (e) => {
    if (e.target.value.length === 0 && (e.which === 46 || e.which === 43 || e.which === 101 || e.which === 69 || e.which === 45)) {
      e.preventDefault();
    } else if (e.which === 43 || e.which === 101 || e.which === 69 || e.which === 45) {
      e.preventDefault();
    }
  }

  checkUpdateAmountField = (event, type) => {
    if (event) {
      const inputName = event.target.name;
      const inputValue = type === 'walletAmount' ? (parseFloat(event.target.value) * 10).toFixed(2) : event.target.value;
      const preValue = this.state[inputName];
      /* eslint-disable */
      const regEx = type === 'walletAmount' ? /^(?:[0-9]+(?:\.[0-9]{0,2})?)?$/ : type === 'beneficiaryName' ? new RegExp('^[a-zA-Z ]*$') : null;
      /* eslint-enable */
      if (regEx.test(inputValue)) {
        this.state[inputName] = inputValue;
        this.setState({ [inputName]: inputValue });
      } else {
        this.state[inputName] = preValue;
        this.setState({ [inputName]: preValue });
      }
    }
  }

  setWalletAmountErrorState = (amount, transferableAmount) => { this.setState({ isWalletamountError: +amount > +transferableAmount }); };

  isWalletAmountValid = (amount, transferableAmount) => +amount > 0 && +amount <= +transferableAmount;

  handleDisableContinueButton = () => {
    if (this.state.selectedDropdownAvailableWalletsInfoText.indexOf('monedero mesa de regalos') > -1) {
      if (this.state.walletNumber_mmdr.length > 0 && this.state.walletAmount_mmdr.length > 0 && this.isWalletAmountValid(this.state.walletAmount_mmdr, this.state.transferenceData.transferableAmount)) {
        this.setWalletAmountErrorState(this.state.walletAmount_mmdr, this.state.transferenceData.transferableAmount);
        this.props.disableContinueButton(false);
      } else {
        this.setWalletAmountErrorState(this.state.walletAmount_mmdr, this.state.transferenceData.transferableAmount);
        this.props.disableContinueButton(true);
      }
    } 
    else if (this.state.selectedDropdownAvailableWalletsInfoText.indexOf('monedero digital') > -1) {
      if (this.state.walletAmount_mdw.length > 0 && this.state.walletAmount_mdw.length > 0 && this.isWalletAmountValid(this.state.walletAmount_mdw, this.state.transferenceData.transferableAmount)) {
        this.setWalletAmountErrorState(this.state.walletAmount_mdw, this.state.transferenceData.transferableAmount);
        this.props.disableContinueButton(false);
      } else {
        this.setWalletAmountErrorState(this.state.walletAmount_mdw, this.state.transferenceData.transferableAmount);
        this.props.disableContinueButton(true);
      }
    }
    else if (this.state.selectedDropdownAvailableWalletsInfoText.indexOf('monedero electronico (e-wallet)') > -1) {
      if (this.state.walletAmount_mew.length > 0 && this.isWalletAmountValid(this.state.walletAmount_mew, this.state.transferenceData.transferableAmount)) {
        this.setWalletAmountErrorState(this.state.walletAmount_mew, this.state.transferenceData.transferableAmount);
        this.props.disableContinueButton(false);
      } else {
        this.setWalletAmountErrorState(this.state.walletAmount_mew, this.state.transferenceData.transferableAmount);
        this.props.disableContinueButton(true);
      }
    } else if (this.state.selectedDropdownAvailableWalletsInfoText.indexOf('monedero liverpool premium card') > -1 || this.state.selectedDropdownAvailableWalletsInfoText.indexOf('monedero tarjeta liverpool') > -1) {
      if (this.state.isUserHasWallet) {
        if (this.state.selectedRadioSavedWalletsInfoValue === '') {
          if (this.state.walletNumber_mltpc && this.state.walletNumber_mltpc.length > 0 && this.state.beneficiaryName_mltpc && this.state.beneficiaryName_mltpc.length > 0 && this.state.walletAmount_mltpc.length > 0 && this.isWalletAmountValid(this.state.walletAmount_mltpc, this.state.transferenceData.transferableAmount)) {
            this.setWalletAmountErrorState(this.state.walletAmount_mltpc, this.state.transferenceData.transferableAmount);
            this.props.disableContinueButton(false);
          } else {
            this.setWalletAmountErrorState(this.state.walletAmount_mltpc, this.state.transferenceData.transferableAmount);
            this.props.disableContinueButton(true);
          }
        } else {
          if (this.state.walletAmount_mltpc.length > 0 && this.isWalletAmountValid(this.state.walletAmount_mltpc, this.state.transferenceData.transferableAmount)) {
            this.setWalletAmountErrorState(this.state.walletAmount_mltpc, this.state.transferenceData.transferableAmount);
            this.props.disableContinueButton(false);
          } else {
            this.setWalletAmountErrorState(this.state.walletAmount_mltpc, this.state.transferenceData.transferableAmount);
            this.props.disableContinueButton(true);
          }
        }
      } else {
        if (this.state.walletNumber_mltpc.length > 0 && this.state.beneficiaryName_mltpc.length > 0 && this.state.walletAmount_mltpc.length > 0 && this.isWalletAmountValid(this.state.walletAmount_mltpc, this.state.transferenceData.transferableAmount)) {
          this.setWalletAmountErrorState(this.state.walletAmount_mltpc, this.state.transferenceData.transferableAmount);
          this.props.disableContinueButton(false);
        } else {
          this.setWalletAmountErrorState(this.state.walletAmount_mltpc, this.state.transferenceData.transferableAmount);
          this.props.disableContinueButton(true);
        }
      }
    }
  }

  checkKeyDownOnlyNumber = (event) => {
    const inputName = event.target.name;
    const regEx = /\d/;
    if (!regEx.test(Number(event.key)) || event.key === 'Backspace') {
      event.preventDefault();
    }
    if (event.key === 'Backspace') {
      const preValue = (parseFloat(this.state[inputName]).toPrecision() / 10).toFixed(2);
      this.state[inputName] = preValue;
      this.setState({ [inputName]: preValue });
      this.handleDisableContinueButton();
    }
  }

  checkUpdateWalletNumber = (e) => {
    if (e) {
      /* eslint-disable */
      const prevVal = this.state[e.target.name];
      const regEx = new RegExp('^[0-9]*$');
      if (e.target.name === 'walletNumber_mmdr') {
        if (regEx.test(e.target.value) && e.target.value.length <= 13) {
          this.state[e.target.name] = e.target.value;
          this.setState({ [e.target.name]: e.target.value });
        } else {
          this.state[e.target.name] = prevVal;
          this.setState({ [e.target.name]: prevVal });
        }
      } else {
        if (regEx.test(e.target.value) && e.target.value.length <= 16) {
          this.state[e.target.name] = e.target.value;
          this.setState({ [e.target.name]: e.target.value });
        } else {
          this.state[e.target.name] = prevVal;
          this.setState({ [e.target.name]: prevVal });
        }
      }
    }
    /* eslint-enable */
  }

  onMonederoClearState = () => {
    this.setState({
      isWalletamountError: null,

      walletNumber_mmdr: '',
      walletAmount_mmdr: '0.00',
      walletAmount_mdw: '0.00',
      walletAmount_mew: '0.00',

      walletAmount_mltpc: '0.00',
      walletNumber_mltpc: '',
      beneficiaryName_mltpc: '',

    });
    this.props.disableContinueButton(true);
  }

  onMonederoInfoSelectChange = (data, e) => {
    this.onMonederoClearState();
    const selectedText = e.target.options[e.target.selectedIndex].text.toLowerCase();
    this.setState({ selectedDropdownAvailableWalletsInfoValue: e.target.value, selectedDropdownAvailableWalletsInfoText: selectedText });
    if (selectedText.indexOf('monedero mesa de regalos') > -1) {
      this.setState({
        isMonederoDigitalWallet: false,
        isMonederoMesadeRegalos: true,
        isMonederoElectronico: false,
        isMonederoLiverpool_TarjetaPremiumCard: false,
        commissionFeeForMMDR: _.find(this.state.transferenceData.availableWalletsInfo, { accountName: data.value }).commissionFee,
      });
    } else if (selectedText.indexOf('monedero electronico (e-wallet)') > -1) {
      this.getEwalletInformation();
      this.setState({
        isMonederoDigitalWallet: false,
        isMonederoMesadeRegalos: false,
        isMonederoElectronico: true,
        isMonederoLiverpool_TarjetaPremiumCard: false,
        commissionFeeForMEE: _.find(this.state.transferenceData.availableWalletsInfo, { accountName: data.value }).commissionFee,
      });
      this.setState({ isMonederoMesadeRegalos: false, isMonederoElectronico: true, isMonederoLiverpool_TarjetaPremiumCard: false });
    } else if (selectedText.indexOf('monedero liverpool premium card') > -1 || selectedText.indexOf('monedero tarjeta liverpool') > -1) {
      this.setState({
        isMonederoDigitalWallet: false,
        isMonederoMesadeRegalos: false,
        isMonederoElectronico: false,
        isMonederoLiverpool_TarjetaPremiumCard: true,
        commissionFeeForMLPC: _.find(this.state.transferenceData.availableWalletsInfo, { accountName: data.value }).commissionFee,
      });
      this.setState({ isMonederoMesadeRegalos: false, isMonederoElectronico: false, isMonederoLiverpool_TarjetaPremiumCard: true });
    } else if (selectedText.indexOf('monedero digital') > -1) {
      this.setState({
        isMonederoMesadeRegalos: false,
        isMonederoElectronico: false,
        isMonederoLiverpool_TarjetaPremiumCard: false,
        isMonederoDigitalWallet: true,
        commissionFeeForMDW: _.find(this.state.transferenceData.availableWalletsInfo, { accountName: data.value }).commissionFee,
      });
    }
    this.setState({ selectedRadioSavedWalletsInfoValue: '' });
  }

  onWalletAmountNumberChange = (e) => {
    /* eslint-disable */
    if (e.target.name === 'walletNumber_mmdr' || e.target.name === 'walletNumber_mltpc') {
      this.checkUpdateWalletNumber(e);
    }
    if (e.target.name === 'walletAmount_mmdr' || e.target.name === 'walletAmount_mdw' || e.target.name === 'walletAmount_mew' || e.target.name === 'walletAmount_mltpc') {
      this.checkUpdateAmountField(e, 'walletAmount');
    }
    if (this.state.selectedDropdownAvailableWalletsInfoText.indexOf('monedero mesa de regalos') > -1) {
      if (this.state.walletNumber_mmdr.length > 0 && this.state.walletAmount_mmdr.length > 0 && +this.state.walletAmount_mmdr > 0 && +this.state.walletAmount_mmdr <= +this.state.transferenceData.transferableAmount) {
        +this.state.walletAmount_mmdr > +this.state.transferenceData.transferableAmount ? this.setState({ isWalletamountError: true }) : this.setState({ isWalletamountError: false });
        this.props.disableContinueButton(false);
      } else {
        +this.state.walletAmount_mmdr > +this.state.transferenceData.transferableAmount ? this.setState({ isWalletamountError: true }) : this.setState({ isWalletamountError: false });
        this.props.disableContinueButton(true);
      }
    } 
    else if (this.state.selectedDropdownAvailableWalletsInfoText.indexOf('monedero digital') > -1) {
      if (this.state.walletAmount_mdw.length > 0 && this.state.walletAmount_mdw.length > 0 && +this.state.walletAmount_mdw > 0 && +this.state.walletAmount_mdw <= +this.state.transferenceData.transferableAmount) {
        +this.state.walletAmount_mdw > +this.state.transferenceData.transferableAmount ? this.setState({ isWalletamountError: true }) : this.setState({ isWalletamountError: false });
        this.props.disableContinueButton(false);
      } else {
        +this.state.walletAmount_mdw > +this.state.transferenceData.transferableAmount ? this.setState({ isWalletamountError: true }) : this.setState({ isWalletamountError: false });
        this.props.disableContinueButton(true);
      }
    }
    else if (this.state.selectedDropdownAvailableWalletsInfoText.indexOf('monedero electronico (e-wallet)') > -1) {
      if (this.state.walletAmount_mew.length > 0 && +this.state.walletAmount_mew > 0 && +this.state.walletAmount_mew <= +this.state.transferenceData.transferableAmount) {
        +this.state.walletAmount_mew > +this.state.transferenceData.transferableAmount ? this.setState({ isWalletamountError: true }) : this.setState({ isWalletamountError: false });
        this.props.disableContinueButton(false);
      } else {
        +this.state.walletAmount_mew > +this.state.transferenceData.transferableAmount ? this.setState({ isWalletamountError: true }) : this.setState({ isWalletamountError: false });
        this.props.disableContinueButton(true);
      }
    } else if (this.state.selectedDropdownAvailableWalletsInfoText.indexOf('monedero liverpool premium card') > -1 || this.state.selectedDropdownAvailableWalletsInfoText.indexOf('monedero tarjeta liverpool') > -1) {
      if (this.state.isUserHasWallet) {
        if (this.state.selectedRadioSavedWalletsInfoValue === '') {
          if (this.state.walletNumber_mltpc && this.state.walletNumber_mltpc.length > 0 && this.state.beneficiaryName_mltpc && this.state.beneficiaryName_mltpc.length > 0 && this.state.walletAmount_mltpc.length > 0 && +this.state.walletAmount_mltpc > 0 && +this.state.walletAmount_mltpc <= +this.state.transferenceData.transferableAmount) {
            +this.state.walletAmount_mltpc > +this.state.transferenceData.transferableAmount ? this.setState({ isWalletamountError: true }) : this.setState({ isWalletamountError: false });
            this.props.disableContinueButton(false);
          } else {
            +this.state.walletAmount_mltpc > +this.state.transferenceData.transferableAmount ? this.setState({ isWalletamountError: true }) : this.setState({ isWalletamountError: false });
            this.props.disableContinueButton(true);
          }
        } else {
          if (this.state.walletAmount_mltpc.length > 0 && +this.state.walletAmount_mltpc > 0 && +this.state.walletAmount_mltpc <= +this.state.transferenceData.transferableAmount) {
            +this.state.walletAmount_mltpc > +this.state.transferenceData.transferableAmount ? this.setState({ isWalletamountError: true }) : this.setState({ isWalletamountError: false });
            this.props.disableContinueButton(false);
          } else {
            +this.state.walletAmount_mltpc > +this.state.transferenceData.transferableAmount ? this.setState({ isWalletamountError: true }) : this.setState({ isWalletamountError: false });
            this.props.disableContinueButton(true);
          }
        }
      } else {
        if (this.state.walletNumber_mltpc.length > 0 && this.state.beneficiaryName_mltpc.length > 0 && this.state.walletAmount_mltpc.length > 0 && +this.state.walletAmount_mltpc > 0 && +this.state.walletAmount_mltpc <= +this.state.transferenceData.transferableAmount) {
          +this.state.walletAmount_mltpc > +this.state.transferenceData.transferableAmount ? this.setState({ isWalletamountError: true }) : this.setState({ isWalletamountError: false });
          this.props.disableContinueButton(false);
        } else {
          +this.state.walletAmount_mltpc > +this.state.transferenceData.transferableAmount ? this.setState({ isWalletamountError: true }) : this.setState({ isWalletamountError: false });
          this.props.disableContinueButton(true);
        }
      }
    }
    /* eslint-enable */
  }

  onBeneficiaryNameChange = (e) => {
    this.checkUpdateAmountField(e, 'beneficiaryName');
    if (
        this.state.walletNumber_mltpc && this.state.walletNumber_mltpc.length > 0 &&
        this.state.beneficiaryName_mltpc && this.state.beneficiaryName_mltpc.length > 0 &&
        this.state.walletAmount_mltpc.length > 0 && +this.state.walletAmount_mltpc > 0 &&
        +this.state.walletAmount_mltpc < +this.state.transferenceData.transferableAmount
      ) {
      this.props.disableContinueButton(false);
    } else {
      this.props.disableContinueButton(true);
    }
  }

  handleRadioSelected = (data, e) => {
    this.setState({ selectedRadioSavedWalletsInfoValue: e.target.value });
    if (this.state.walletAmount_mltpc.length > 0 &&
      (this.state.walletAmount_mltpc.length > 0 && +this.state.walletAmount_mltpc < +this.state.transferenceData.transferableAmount)) {
      this.props.disableContinueButton(false);
    } else {
      this.props.disableContinueButton(true);
    }
  }

  onNuevaCuentaClick = () => {
    this.setState({ selectedRadioSavedWalletsInfoValue: '' });
    this.setState({ isNuevaCuentaDisabled: true, isMonederoLiverpool_TarjetaPremiumCard_New: true });
    this.props.disableContinueButton(true);
  }

  onUserDoesNotHasWalletFormClick = () => {
    this.setState({ selectedRadioSavedWalletsInfoValue: '' });
  }

  getFormData = () => {
    let reqParams = {};
    if (this.state.selectedDropdownAvailableWalletsInfoText.indexOf('monedero mesa de regalos') > -1) {
      reqParams = {
        walletType: _.find(this.state.transferenceData.availableWalletsInfo, { accountName: this.state.selectedDropdownAvailableWalletsInfoValue }).accountName,
        walletOrEmployeeCardAmount: this.state.walletAmount_mmdr,
        totalAmount: this.state.transferenceData.transferableAmount,
        walletNumber: this.state.walletNumber_mmdr,
      };
    } else if (this.state.selectedDropdownAvailableWalletsInfoText.indexOf('monedero digital') > -1) {
      reqParams = {
        walletType: _.find(this.state.transferenceData.availableWalletsInfo, { accountName: this.state.selectedDropdownAvailableWalletsInfoValue }).accountName,
        walletOrEmployeeCardAmount: this.state.walletAmount_mdw,
        totalAmount: this.state.transferenceData.transferableAmount,
        walletNumber: this.props.user.digitalWalletAccNumber,
      };
    } else if (this.state.selectedDropdownAvailableWalletsInfoText.indexOf('monedero electronico (e-wallet)') > -1) {
      reqParams = {
        walletType: _.find(this.state.transferenceData.availableWalletsInfo, { accountName: this.state.selectedDropdownAvailableWalletsInfoValue }).accountName,
        walletOrEmployeeCardAmount: this.state.walletAmount_mew,
        totalAmount: this.state.transferenceData.transferableAmount,
        walletNumber: this.state.eWalletNumber ? this.state.eWalletNumber : '',
      };
    } else if (
        this.state.selectedDropdownAvailableWalletsInfoText.indexOf('monedero liverpool premium card') > -1 ||
        this.state.selectedDropdownAvailableWalletsInfoText.indexOf('monedero tarjeta liverpool') > -1) {
      if (this.state.selectedRadioSavedWalletsInfoValue === '') {
        reqParams = {
          walletType: _.find(this.state.transferenceData.availableWalletsInfo, { accountName: this.state.selectedDropdownAvailableWalletsInfoValue }).accountName,
          walletOrEmployeeCardAmount: this.state.walletAmount_mltpc,
          totalAmount: this.state.transferenceData.transferableAmount,
          walletNumber: this.state.walletNumber_mltpc,
          walletHolderName: this.state.beneficiaryName_mltpc,
        };
      } else {
        reqParams = {
          walletType: _.find(this.state.transferenceData.availableWalletsInfo, { accountName: this.state.selectedDropdownAvailableWalletsInfoValue }).accountName,
          walletOrEmployeeCardAmount: this.state.walletAmount_mltpc,
          totalAmount: this.state.transferenceData.transferableAmount,
          walletOrEmployeeIdentifierId: _.find(this.state.transferenceData.savedWalletsInfo, { accountId: this.state.selectedRadioSavedWalletsInfoValue }).accountId,
          accountNumber: _.find(this.state.transferenceData.savedWalletsInfo, { accountId: this.state.selectedRadioSavedWalletsInfoValue }).accountNumber,
        };
      }
    }
    return reqParams;
  }

  render() {
    const webRow = 'col-xs-4';
    const wapRow = 'col-xs-12';

    const nuevaCuentaButtonJson = {
      name: 'Nueva cuenta / tarjeta',
      type: 'button',
      autoFocus: false,
      classname: 'btnSecondarySpecial size-Medium',
      value: 'Nueva cuenta / tarjeta',
      onClickHandler: this.onNuevaCuentaClick,
      disabled: this.state.isNuevaCuentaDisabled,
    };

    const availableWalletsInfo = {
      id: 'availableWalletsInfo',
      optionCaption: 'Selecciona un monedero',
      optionText: 'labelResourceId',
      optionValue: 'value',
      options: [],
    };

    const iconStyle = {
      fontWeight: 700,
      paddingRight: '1%',
    };

    const iconStyleWAP = {
      fontWeight: 700,
      paddingRight: '1%',
      width: '100%',
    };

    const iconTextWAP = {
      fontFamily: 'Roboto, sans-serif',
      fontSize: '16px',
      color: '#333333',
      fontWeight: 400,
      paddingLeft: '1%',
    };

    /* eslint-disable */
    this.state.transferenceData.availableWalletsInfo.map((wallet) => {
      availableWalletsInfo.options.push({
        value: wallet.accountName,
        labelResourceId: +wallet.commissionFee !== 0 ? wallet.accountName + ' ' + '(' + wallet.commissionFee + '%' + ' ' + 'comisión' + ')' :
          wallet.accountName + ' ' + '(' + 'Sin' + ' ' + 'comisión' + ')',
      });
    });
    /* eslint-enable */

    const savedWalletsInfo = {
      name: 'savedWalletsInfo',
      options: [],
    };

    if (this.state.transferenceData && this.state.transferenceData.savedWalletsInfo) {
      this.state.transferenceData.savedWalletsInfo.map(wallet =>
        savedWalletsInfo.options.push({
          id: 'radio_' + wallet.accountId,
          value: wallet.accountId,
          displayName: <span>{wallet.accountType}</span>,
          subDetailsHTML: <p>{wallet.accountNumber}</p>,
          selected: false,
        }),
      );
    }

    const userHasWallet = (
      <div>
        <div className="row">
          <div className={channel === constChannels.WEB ? webRow : wapRow}>
            <form className="margin20">
              <span className="titleForm">Selecciona la cuenta o tarjeta</span>
              <div>
                {savedWalletsInfo.options.map((option, index) => (
                  <div className="radio_group" key={index}>
                    <RadioButton
                      checked={this.state.selectedRadioSavedWalletsInfoValue === option.value}
                      displayName={option.displayName}
                      id={option.id}
                      value={option.value}
                      name="savedWalletsInfo"
                      radioCssClass={'radio selectCard radioDF'}
                      subDetailsHTML={option.subDetailsHTML}
                      onChangeFunction={this.handleRadioSelected}
                    />
                  </div>
                ))}
              </div>
            </form>
          </div>
          <div className="col-md-8 col-sm-8 addNewCard">
            <InputButton buttonAttr={nuevaCuentaButtonJson} />
          </div>
        </div>
        <div className="row">
          {this.state.isMonederoLiverpool_TarjetaPremiumCard_New ?
            <div onClick={this.onUserDoesNotHasWalletFormClick}>
              <div className="col-xs-12">
                <div className="row">
                  <div className={channel === constChannels.WEB ? webRow : wapRow}>
                    <div className="formBlock">
                      <TextInput
                        parentClassName={this.state.isWalletamountError ? 'materialStyle input-group error' : 'materialStyle input-group'}
                        className="inputMaterial"
                        labelClassName="placeHolderMaterial"
                        star="*"
                        onChange={this.onWalletAmountNumberChange}
                        name="walletNumber_mltpc"
                        inputValue={this.state.walletNumber_mltpc}
                        label="Número de cuenta"
                        required
                        maxlength="16"
                        ref={txt => this.walletNumber_mltpc = txt}
                      />
                      <p
                        className="quantityBlockLabel"
                        style={
                          channel === constChannels.WEB
                            ? {
                              marginTop: '-30px',
                              marginBottom: '30px',
                              color: '#333333',
                            }
                            : {
                              marginTop: '-15px',
                              marginBottom: '30px',
                              color: '#333333',
                              fontSize: '12px',
                            }
                          }
                      >
                          El número de digitos del monedero debe ser 13 o 16
                        </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xs-12">
                <div className="row">
                  <div className={channel === constChannels.WEB ? webRow : wapRow}>
                    <div className="formBlock">
                      <TextInput
                        parentClassName={this.state.isWalletamountError ? 'materialStyle input-group error' : 'materialStyle input-group'}
                        className="inputMaterial"
                        labelClassName="placeHolderMaterial"
                        star="*"
                        maxlength="100"
                        required
                        onChange={this.onBeneficiaryNameChange}
                        name="beneficiaryName_mltpc"
                        inputValue={this.state.beneficiaryName_mltpc}
                        label="Nombre del beneficiario"
                        ref={txt => this.beneficiaryName_mltpc = txt}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            : null}
        </div>
      </div>
    );

    return (
      /* eslint-disable */
      <div className="monedero-container">
        {
          channel === constChannels.WAP ? 
          <div className="innerForm display-block" id="option1" >
            <div className="col-xs-12">
              <SelectionTab
                classname="cSelect required"
                id={availableWalletsInfo.id}
                options={availableWalletsInfo.options}
                optionCaption={'Selecciona un monedero'}
                optionText={'labelResourceId'}
                optionValue={'value'}
                onClickHandler={this.handleOutsideClick}
                handleSelectedOption={this.onMonederoInfoSelectChange}
              />
              {this.state.isMonederoDigitalWallet ? 
                <div className="col-xs-12" style={{padding: 0}}>
                  <div className="row">
                    <div className={channel === constChannels.WEB ? webRow : wapRow}>
                      <div className="quantityBlock">
                        <TextInput
                          beforeElement={<span className="input-group-addon">$</span>}
                          parentClassName={this.state.isWalletamountError ? 'monedero-inputbtn materialStyle input-group error' : 'monedero-inputbtn materialStyle input-group'}
                          className="typeNumber inputMaterial no-padding"
                          style={{ padding: 0 }}
                          labelClassName="placeHolderMaterial"
                          onChange={this.onWalletAmountNumberChange}
                          onKeyDown={this.checkKeyDownOnlyNumber}
                          name="walletAmount_mdw"
                          maxlength="10"
                          required
                          inputValue={this.state.walletAmount_mdw}
                          label="Ingresa la cantidad a retirar"
                          ref={txt => this.walletAmount_mdw = txt}
                        />
                      </div>
                      {this.state.isWalletamountError ? <p><small className="input-group-error-label">La cantidad debe ser menor o igual a la disponible para retiro</small></p> : null}
                      {+this.state.commissionFeeForMDW !== 0.0 
                      ? <br /> 
                      : 
                      <p
                        style={
                          channel === constChannels.WEB 
                            ? {
                              color: '#333333'
                            } 
                            : {
                              color: '#333333',
                              fontSize: '12px'
                            }
                        }
                        className="quantityBlockLabel">
                        Sin comisión por depósito a monedero
                      </p>
                      }
                    </div>
                    <div className="col-xs-12" style={{paddingTop: '5%'}}>
                    <i 
                      className="iClass icon-ayuda display-inline-block tooltip-container text-pink"
                      style={iconStyleWAP}
                    >
                      <span className="text" style={iconTextWAP}>Disponible para retiro</span>&nbsp;&nbsp;
                      <span className="tooltip-box">
                        {commonUtil.getLabel(this.props.lables['Estado de Cuenta Page'], 'eventClosure.tarjetaLiverpool.tooltip')}
                      </span>
                    </i>
                      <div className="quantityBlock"><strong className="quantity">{commonUtil.getCurrency(this.state.transferenceData.transferableAmount)}</strong></div>
                    </div>
                  </div>
                </div> : null}

               {/* Monedero de Mesa de Regalos           */}
              {this.state.isMonederoMesadeRegalos ?
                <div>
                  <div className="formBlock accountTransference">
                    <TextInput
                      className="inputMaterial"
                      labelClassName="placeHolderMaterial"
                      star="*"
                      onChange={this.onWalletAmountNumberChange}
                      onKeyPress={this.onExceptionKeysCheck}
                      type="number"
                      name="walletNumber_mmdr"
                      maxlength="13"
                      required
                      inputValue={this.state.walletNumber_mmdr}
                      label=" Número de Monedero"
                      ref={txt => this.walletNumber_mmdr = txt}
                    />
                    <p 
                      className="quantityBlockLabel"
                      style={
                        channel === constChannels.WEB 
                          ? {
                            marginTop: '-23px', 
                            marginBottom: '30px',
                            color: '#333333'
                          } 
                          : {
                            marginTop: '-15px', 
                            marginBottom: '30px',
                            color: '#333333',
                            fontSize: '12px'
                          }
                        }
                    >
                      El número de digitos del monedero debe ser 13 o 16
                    </p>
                  </div>
                  <div className="col-xs-12"
                    style={channel === constChannels.WAP ? {padding: 0} : null }>
                    {
                      channel === constChannels.WEB ?
                        <React.Fragment>
                          
                    <i 
                      className="iClass icon-ayuda display-inline-block tooltip-container text-pink"
                      style={iconStyleWAP}
                    >
                      <span className="text" style={iconTextWAP}>Disponible para retiro</span>&nbsp;&nbsp;
                      <span className="tooltip-box">
                        {commonUtil.getLabel(this.props.lables['Estado de Cuenta Page'], 'eventClosure.tarjetaLiverpool.tooltip')}
                      </span>
                    </i>
                    <div className="quantityBlock">
                      <strong className="quantity">
                        {commonUtil.getCurrency(this.state.transferenceData.transferableAmount)}
                      </strong>
                    </div>
                        </React.Fragment>
                      :null
                    }
                    
                    <div className="formBlock quantityBlock accountTransference">
                      <TextInput
                        beforeElement={<span className="input-group-addon">$</span>}
                        parentClassName={this.state.isWalletamountError ? 'monedero-inputbtn materialStyle input-group error' : 'monedero-inputbtn materialStyle input-group'}
                        className="typeNumber inputMaterial no-padding"
                        style={{ padding: 0 }}
                        labelClassName="placeHolderMaterial"
                        onChange={this.onWalletAmountNumberChange}
                        onKeyPress={this.onExceptionKeysCheckForAmount}
                        onKeyDown={this.checkKeyDownOnlyNumber}
                        type="number"
                        name="walletAmount_mmdr"
                        maxlength="10"
                        required
                        inputValue={this.state.walletAmount_mmdr}
                        label="Ingresa la cantidad a retirar"
                        ref={txt => this.walletAmount_mmdr = txt}
                      />
                      {this.state.isWalletamountError ? <p><small className="input-group-error-label">La cantidad debe ser menor o igual a la disponible para retiro</small></p> : null}
                      {+this.state.commissionFeeForMMDR !== 0.0 
                      ? <br /> 
                      : <p
                        style={
                          channel === constChannels.WEB 
                            ? {
                              color: '#333333'
                            } 
                            : {
                              color: '#333333',
                              fontSize: '12px'
                            }
                        }
                        className="quantityBlockLabel">
                        Sin comisión por depósito a monedero
                      </p>}
                    </div>
                    {
                      channel === constChannels.WAP ?
                      <div style={{paddingTop: '6%'}}>                        
                          <i 
                            className="iClass icon-ayuda display-inline-block tooltip-container text-pink"
                            style={iconStyleWAP}
                          >
                          <span className="text" style={iconTextWAP}>Disponible para retiro</span>&nbsp;&nbsp;
                          <span className="tooltip-box">
                            {commonUtil.getLabel(this.props.lables['Estado de Cuenta Page'], 'eventClosure.tarjetaLiverpool.tooltip')}
                          </span>
                           </i>
                        <div className="quantityBlock">
                          <strong className="quantity">
                            {commonUtil.getCurrency(this.state.transferenceData.transferableAmount)}
                          </strong>
                        </div>
                      </div>
                      :null
                    }
                  </div>

                </div>
                // </div>
                : null}
              {this.state.isMonederoElectronico ?
                <div>
                  <div>                    
                    <i 
                      className="iClass icon-ayuda display-inline-block tooltip-container text-pink"
                      style={iconStyleWAP}
                    >
                      <span className="tooltip-box">
                        {commonUtil.getLabel(this.props.lables['Estado de Cuenta Page'], 'eventClosure.tarjetaLiverpool.tooltip')}</span>
                    </i>
                    <span className="text" style={iconTextWAP}>Disponible para retiro</span>&nbsp;&nbsp;
                    <div className="quantityBlock"><strong className="quantity">{commonUtil.getCurrency(this.state.transferenceData.transferableAmount)}</strong></div>
                    <p>{this.state.walletStatus ? this.state.eWalletNumber : this.state.walleterrorMessage}</p>
                  </div>
                  <div className="quantityBlock">
                    <TextInput
                      beforeElement={<span className="input-group-addon">$</span>}
                      parentClassName={this.state.isWalletamountError ? 'monedero-inputbtn materialStyle input-group error' : 'monedero-inputbtn materialStyle input-group'}
                      className="inputMaterial no-padding"
                      style={{ padding: 0 }}
                      labelClassName="placeHolderMaterial"
                      onChange={this.onWalletAmountNumberChange}
                      onKeyDown={this.checkKeyDownOnlyNumber}
                      // onKeyPress={this.onExceptionKeysCheckForAmount}
                      type="number"
                      name="walletAmount_mew"
                      maxlength="10"
                      required
                      inputValue={this.state.walletAmount_mew}
                      label="Ingresa la cantidad a retirar"
                      ref={txt => this.walletAmount_mew = txt}
                    />
                    {this.state.isWalletamountError ? <p><small className="input-group-error-label">La cantidad debe ser menor o igual a la disponible para retiro</small></p> : null}
                    {+this.state.commissionFeeForMEE !== 0.0 
                    ? <br /> 
                    : <small className="quantityBlockLabel" style={{color: '#333333'}}>
                        Sin comisión por depósito a monedero
                      </small>}
                  </div>
                  <div class="quantity" > <small>{this.state.walletStatus ? this.state.eWalletNumber : this.state.walleterrorMessage}</small> </div>
                </div>
                : null}

              {this.state.isMonederoLiverpool_TarjetaPremiumCard ?
                <div>

                  <div>
                    <div className="accountTransference">
                      <TextInput
                        className="inputMaterial"
                        labelClassName="placeHolderMaterial"
                        star="*"
                        onChange={this.onWalletAmountNumberChange}
                        onKeyPress={this.onExceptionKeysCheck}
                        type="number"
                        name="walletNumber_mltpc"
                        maxlength="16"
                        inputValue={this.state.walletNumber_mltpc}
                        label="Número de Monedero"
                        required
                        ref={txt => this.walletNumber_mltpc = txt}
                      />
                      <p 
                        className="quantityBlockLabel"
                        style={
                          channel === constChannels.WEB 
                            ? {
                              marginTop: '-30px', 
                              marginBottom: '30px',
                              color: '#333333'
                            } 
                            : {
                              marginTop: '-15px', 
                              marginBottom: '30px',
                              color: '#333333',
                              fontSize: '12px'
                            }
                          }
                      >
                        El número de digitos del monedero debe ser 13 o 16
                      </p>
                    </div>
                  </div>

                  {this.state.isUserHasWallet ?
                    userHasWallet
                    : <div>
                      {
                      channel === constChannels.WEB ?
                      <div>
                          <i 
                            className="iClass icon-ayuda display-inline-block tooltip-container text-pink"
                            style={iconStyleWAP}
                          >
                            <span className="text" style={iconTextWAP}>Disponible para retiro</span>&nbsp;&nbsp;
                          <span className="tooltip-box">
                            {commonUtil.getLabel(this.props.lables['Estado de Cuenta Page'], 'eventClosure.tarjetaLiverpool.tooltip')}
                          </span>
                           </i>
                        <div className="quantityBlock">
                          <strong className="quantity">
                            {commonUtil.getCurrency(this.state.transferenceData.transferableAmount)}
                          </strong>
                        </div>
                      </div>
                      :null
                    }
                      <div className="quantityBlock accountTransference">
                        <TextInput
                          beforeElement={<span className="input-group-addon">$</span>}
                          parentClassName={this.state.isWalletamountError ? 'monedero-inputbtn materialStyle input-group error' : 'monedero-inputbtn materialStyle input-group'}
                          className="inputMaterial no-padding"
                          style={{ padding: 0 }}
                          labelClassName="placeHolderMaterial"
                          onChange={this.onWalletAmountNumberChange}
                          onKeyDown={this.checkKeyDownOnlyNumber}
                          onKeyPress={this.onExceptionKeysCheckForAmount}
                          type="number"
                          name="walletAmount_mltpc"
                          maxlength="10"
                          required
                          inputValue={this.state.walletAmount_mltpc}
                          label="Ingresa la cantidad a retirar"
                          ref={txt => this.walletAmount_mltpc = txt}
                        />
                        {this.state.isWalletamountError ? <p><small className="input-group-error-label">La cantidad debe ser menor o igual a la disponible para retiro</small></p> : null}
                        {+this.state.commissionFeeForMLPC !== 0.0 
                        ? <br /> 
                        : <small className="quantityBlockLabel" style={{color: '#333333'}}>
                            Sin comisión por depósito a monedero
                          </small>}
                      </div>

                      <div style={channel === constChannels.WAP ? {marginTop: '8%'} : ''}>
                        <TextInput
                          className="inputMaterial"
                          labelClassName="placeHolderMaterial"
                          star="*"
                          onChange={this.onBeneficiaryNameChange}
                          maxlength="100"
                          name="beneficiaryName_mltpc"
                          inputValue={this.state.beneficiaryName_mltpc}
                          label="Nombre del beneficiario"
                          required
                          ref={txt => this.beneficiaryName_mltpc = txt}
                        />
                      </div>

                      {
                      channel === constChannels.WAP ?
                      <div style={{paddingTop: '6%'}}>                        
                          <i 
                            className="iClass icon-ayuda display-inline-block tooltip-container text-pink"
                            style={iconStyleWAP}
                          >
                          <span className="text" style={iconTextWAP}>Disponible para retiro</span>&nbsp;&nbsp;
                          <span className="tooltip-box">
                            {commonUtil.getLabel(this.props.lables['Estado de Cuenta Page'], 'eventClosure.tarjetaLiverpool.tooltip')}
                          </span>
                           </i>
                        <div className="quantityBlock">
                          <strong className="quantity">
                            {commonUtil.getCurrency(this.state.transferenceData.transferableAmount)}
                          </strong>
                        </div>
                      </div>
                      :null
                    }
                    </div>}

                </div>
                : null}
            </div>
          </div>
            :
            // code for web
            <div className="row display-block" id="option1">
              <div className='col-xs-4'>
                <SelectionTab
                  classname="cSelect required"
                  id={availableWalletsInfo.id}
                  options={availableWalletsInfo.options}
                  optionCaption={'Selecciona un monedero'}
                  optionText={'labelResourceId'}
                  optionValue={'value'}
                  handleSelectedOption={this.onMonederoInfoSelectChange}
                />
              </div>

              {this.state.isMonederoMesadeRegalos ?
                <div>
                  <div className="col-xs-12">
                    <div className="row">
                      <div className={channel === constChannels.WEB ? webRow : wapRow}>
                        <div className="formBlock">
                          <TextInput
                            className="inputMaterial"
                            labelClassName="placeHolderMaterial"
                            star="*"
                            onChange={this.onWalletAmountNumberChange}
                            name="walletNumber_mmdr"
                            maxlength="16"
                            required
                            inputValue={this.state.walletNumber_mmdr}
                            label=" Número de Monedero"
                            ref={txt => this.walletNumber_mmdr = txt}
                          />
                          <p 
                            className="quantityBlockLabel"
                            style={
                              channel === constChannels.WEB 
                                ? {
                                  marginTop: '-23px', 
                                  marginBottom: '30px',
                                  color: '#333333'
                                } 
                                : {
                                  marginTop: '-15px', 
                                  marginBottom: '30px',
                                  color: '#333333',
                                  fontSize: '12px'
                                }
                              }
                          >
                              El número de digitos del monedero debe ser 13 o 16
                          </p>
                        </div>                        
                      </div>
                    </div>
                  </div>
                  <div className="col-xs-12">
                    <div className="row">
                      <div className={channel === constChannels.WEB ? webRow : wapRow}>
                        <div className="quantityBlock">
                          <TextInput
                            beforeElement={<span className="input-group-addon">$</span>}
                            parentClassName={this.state.isWalletamountError ? 'monedero-inputbtn materialStyle input-group error' : 'monedero-inputbtn materialStyle input-group'}
                            className="typeNumber inputMaterial"
                            style={{padding: 0}}
                            labelClassName="placeHolderMaterial"
                            onChange={this.onWalletAmountNumberChange}
                            onKeyDown={this.checkKeyDownOnlyNumber}
                            name="walletAmount_mmdr"
                            maxlength="10"
                            required
                            inputValue={this.state.walletAmount_mmdr}
                            label="Ingresa la cantidad a retirar"
                            ref={txt => this.walletAmount_mmdr = txt}
                          />
                        </div>
                        {this.state.isWalletamountError ? <p><small className="input-group-error-label">
                          La cantidad debe ser menor o igual a la disponible para retiro</small></p> : null
                        }
                        {+this.state.commissionFeeForMMDR !== 0.0 ? 
                        <br /> 
                        : 
                        <p 
                          style={{color: '#333333'}}
                          className="quantityBlockLabel">
                            Sin comisión por depósito a monedero
                        </p>}
                      </div>
                      <div className="col-xs-12" style={{paddingTop: '2%'}}>                                                
                        <i 
                          className="iClass icon-ayuda display-inline-block tooltip-container text-pink"
                          style={iconStyle}
                        >
                            <span 
                            className={`tooltip-box tooltipBox344  tooltipIcon344`}
                            >
                              <p style={{fontSize: '16px', fontWeight: 500, padding: '0 2%'}}>
                                  Monto disponible
                              </p>
                              <p style={{padding: '0 2%'}}> 
                                {commonUtil.getLabel(this.props.lables['Estado de Cuenta Page'], 'eventClosure.tarjetaLiverpool.tooltip')}
                              </p>
                           </span>
                        </i>
                        <span className="text" style={{ fontSize: '16px' }}>Disponible para retiro</span>&nbsp;&nbsp;
                        <div className="quantityBlock"><strong className="quantity">{commonUtil.getCurrency(this.state.transferenceData.transferableAmount)}</strong></div>
                      </div>
                    </div>
                  </div>
                </div>
                : null
              }

              {this.state.isMonederoElectronico ?
                <div>
                  <div className="col-xs-12">
                    <div className="row">
                      <div className="col-xs-4">
                        <div className="quantityBlock">
                          <TextInput
                            beforeElement={<span className="input-group-addon">$</span>}
                            parentClassName={this.state.isWalletamountError ? 'monedero-inputbtn materialStyle input-group error' : 'monedero-inputbtn materialStyle input-group'}
                            className="inputMaterial"
                            labelClassName="placeHolderMaterial"
                            style={{ padding: 0 }}
                            onChange={this.onWalletAmountNumberChange}
                            onKeyDown={this.checkKeyDownOnlyNumber}
                            name="walletAmount_mew"
                            maxlength="10"
                            required
                            inputValue={this.state.walletAmount_mew}
                            label="Ingresa la cantidad a retirar"
                            ref={txt => this.walletAmount_mew = txt}
                          />
                          {this.state.isWalletamountError ? <p><small className="input-group-error-label">La cantidad debe ser menor o igual a la disponible para retiro</small></p> : null}
                          {+this.state.commissionFeeForMEE !== 0.0 
                          ? <br /> 
                          : <p 
                            style={{color: '#333333'}}
                            className="quantityBlockLabel">
                              Sin comisión por depósito a monedero
                            </p>
                          }
                        </div>

                      </div>
                      <div className="col-xs-12" style={{paddingTop: '2%'}}>                                              
                        <i 
                          className="iClass icon-ayuda display-inline-block tooltip-container text-pink"
                          style={iconStyle}
                        >
                            <span 
                            className={`tooltip-box tooltipBox344  tooltipIcon344`}
                            >
                              <p style={{fontSize: '16px', fontWeight: 500, padding: '0 2%'}}>
                                  Monto disponible
                              </p>
                              <p style={{padding: '0 2%'}}> 
                                {commonUtil.getLabel(this.props.lables['Estado de Cuenta Page'], 'eventClosure.tarjetaLiverpool.tooltip')}
                              </p>
                           </span>
                        </i>
                        <span className="text" style={{ fontSize: '16px' }}>Disponible para retiro</span>&nbsp;&nbsp;  
                        <div className="quantityBlock"><strong className="quantity">{commonUtil.getCurrency(this.state.transferenceData.transferableAmount)}</strong>
                          <div class="quantity" > <small>{this.state.walletStatus ? this.state.eWalletNumber : this.state.walleterrorMessage}</small> </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                : null
              }

              {this.state.isMonederoLiverpool_TarjetaPremiumCard ?
                <div>
                  <div className="col-xs-12">
                    <div className="row">
                      <div className={channel === constChannels.WEB ? webRow : wapRow}>
                        <div className="formBlock">
                          <TextInput
                            className="inputMaterial"
                            labelClassName="placeHolderMaterial"
                            star="*"
                            onChange={this.onWalletAmountNumberChange}
                            name="walletNumber_mltpc"
                            maxlength="16"
                            inputValue={this.state.walletNumber_mltpc}
                            label="Número de Monedero"
                            required
                            ref={txt => this.walletNumber_mltpc = txt}
                          />
                          <p 
                            className="quantityBlockLabel"
                            style={
                              channel === constChannels.WEB 
                                ? {
                                  marginTop: '-23px', 
                                  marginBottom: '30px',
                                  color: '#333333'
                                } 
                                : {
                                  marginTop: '-15px', 
                                  marginBottom: '30px',
                                  color: '#333333',
                                  fontSize: '12px'
                                }
                              }
                          >
                              El número de digitos del monedero debe ser 13 o 16
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  {this.state.isUserHasWallet ?
                    userHasWallet
                    : <div>
                      <div className="col-xs-12">
                        <div className="row">
                          <div className="col-xs-4">
                            <div className="quantityBlock">
                              <TextInput
                                beforeElement={<span className="input-group-addon">$</span>}
                                parentClassName={this.state.isWalletamountError ? 'monedero-inputbtn materialStyle input-group error' : 'monedero-inputbtn materialStyle input-group'}
                                className="inputMaterial"
                                style={{ padding: 0 }}
                                labelClassName="placeHolderMaterial"
                                onChange={this.onWalletAmountNumberChange}
                                onKeyDown={this.checkKeyDownOnlyNumber}
                                name="walletAmount_mltpc"
                                maxlength="10"
                                required
                                inputValue={this.state.walletAmount_mltpc}
                                label="Ingresa la cantidad a retirar"
                                ref={txt => this.walletAmount_mltpc = txt}
                              />
                              {this.state.isWalletamountError ? <p><small className="input-group-error-label">La cantidad debe ser menor o igual a la disponible para retiro</small></p> : null}
                              {+this.state.commissionFeeForMLPC !== 0.0 
                              ? 
                              <br /> 
                              : 
                              <p className="quantityBlockLabel" style={{color: '#333333'}}>
                                Sin comisión por depósito a monedero
                              </p>}
                            </div>
                          </div>                          
                        </div>
                      </div>
                      <div className="col-xs-12" style={{paddingTop: '2%'}}>
                        <div className="row">
                          <div className="col-xs-4">
                            <div className="formBlock">
                              <TextInput
                                className="inputMaterial"
                                labelClassName="placeHolderMaterial"
                                star="*"
                                onChange={this.onBeneficiaryNameChange}
                                maxlength="100"
                                name="beneficiaryName_mltpc"
                                inputValue={this.state.beneficiaryName_mltpc}
                                label="Nombre del beneficiario"
                                required
                                ref={txt => this.beneficiaryName_mltpc = txt}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-xs-12" style={{paddingTop: '2%'}}>
                      <i 
                          className="iClass icon-ayuda display-inline-block tooltip-container text-pink"
                          style={iconStyle}
                        >
                            <span 
                            className={`tooltip-box tooltipBox344  tooltipIcon344`}
                            >
                              <p style={{fontSize: '16px', fontWeight: 500, padding: '0 2%'}}>
                                  Monto disponible
                              </p>
                              <p style={{padding: '0 2%'}}> 
                                {commonUtil.getLabel(this.props.lables['Estado de Cuenta Page'], 'eventClosure.tarjetaLiverpool.tooltip')}
                              </p>
                           </span>
                        </i>
                        <span className="text" style={{ fontSize: '16px' }}>Disponible para retiro</span>&nbsp;&nbsp;
                            <div className="quantityBlock"><strong className="quantity">{commonUtil.getCurrency(this.state.transferenceData.transferableAmount)}</strong></div>
                          </div>
                    </div>}

                </div>
                : null
              }

                {this.state.isMonederoDigitalWallet ? 
                  <div className="col-xs-12">
                    <div className="row">
                      <div className={channel === constChannels.WEB ? webRow : wapRow}>
                        <div className="quantityBlock">
                          <TextInput
                            beforeElement={<span className="input-group-addon">$</span>}
                            parentClassName={this.state.isWalletamountError ? 'monedero-inputbtn materialStyle input-group error' : 'monedero-inputbtn materialStyle input-group'}
                            className="typeNumber inputMaterial"
                            style={{ padding: 0 }}
                            labelClassName="placeHolderMaterial"
                            onChange={this.onWalletAmountNumberChange}
                            onKeyDown={this.checkKeyDownOnlyNumber}
                            name="walletAmount_mdw"
                            maxlength="10"
                            required
                            inputValue={this.state.walletAmount_mdw}
                            label="Ingresa la cantidad a retirar"
                            ref={txt => this.walletAmount_mdw = txt}
                          />
                        </div>
                        {this.state.isWalletamountError ? <p><small className="input-group-error-label">La cantidad debe ser menor o igual a la disponible para retiro</small></p> : null}
                        {+this.state.commissionFeeForMDW !== 0.0 
                        ? <br /> 
                        : <p className="quantityBlockLabel" style={{color: '#333333'}}>
                          Sin comisión por depósito a monedero
                        </p>}
                      </div>
                      <div className="col-xs-12" style={{paddingTop: '2%'}}>                        
                        <i 
                          className="iClass icon-ayuda display-inline-block tooltip-container text-pink"
                          style={iconStyle}
                        >
                            <span 
                            className={`tooltip-box tooltipBox344  tooltipIcon344`}
                            >
                              <p style={{fontSize: '16px', fontWeight: 500, padding: '0 2%'}}>
                                  Monto disponible
                              </p>
                              <p style={{padding: '0 2%'}}> 
                                {commonUtil.getLabel(this.props.lables['Estado de Cuenta Page'], 'eventClosure.tarjetaLiverpool.tooltip')}
                              </p>
                           </span>
                        </i>
                        <span className="text" style={{ fontSize: '16px' }}>Disponible para retiro</span>&nbsp;&nbsp;
                        <div className="quantityBlock"><strong className="quantity">{commonUtil.getCurrency(this.state.transferenceData.transferableAmount)}</strong></div>
                      </div>
                    </div>
                  </div> : null
                }
            </div>
        }
      </div >
      /* eslint-enable */
    );
  }
}
